<template>
  <div class="orders">
    <b-breadcrumb :items="breadcrumb"></b-breadcrumb>
    <router-view></router-view>
  </div>
</template>
<script>
import { BBreadcrumb } from 'bootstrap-vue'

export default {
  components: {
    BBreadcrumb
  },
  data () {
    return {
      breadcrumb: [
        {
          text: 'Dashboard',
          to: { name: 'dashboard' }
        },
        {
          text: 'Ventas',
          to: { name: 'sales' }
        },
        {
          text: 'Nueva Venta',
          active: true
        }
      ]
    }
  }
}
</script>
